import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardSegmentosClientesComponent } from './dashboard-segmentos-clientes/dashboard-segmentos-clientes.component';
import { DashboardParcelasPagasVencidasComponent } from './dashboard-parcelas-pagas-vencidas/dashboard-parcelas-pagas-vencidas.component';
import { DashboardHistoricoCreditosComponent } from './dashboard-historico-creditos/dashboard-historico-creditos.component';
import { DashboardPagamentosPorClientesComponent } from './dashboard-pagamentos-por-clientes/dashboard-pagamentos-por-clientes.component';

const routes: Routes = [
  {
    path: 'segmentos-clientes',
    component: DashboardSegmentosClientesComponent
  },
  {
    path: 'parcelas-pagas-vencidas',
    component: DashboardParcelasPagasVencidasComponent
  },
  {
    path: 'historico-creditos',
    component: DashboardHistoricoCreditosComponent
  },
  {
    path: 'pagamentos-clientes',
    component: DashboardPagamentosPorClientesComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NovoDashboardRoutingModule { }
